import { useFormik } from 'formik';
import { useDispatch, useSelector} from 'react-redux';
import { useState, useRef ,useEffect } from 'react';
import { formValues,validation } from './profileValidation';


import {  Loader } from '../../../utils/tools'
import { errorHelper } from '../../../utils/tools';
import { updateUserProfile,getuserDetails } from '../../../store/actions/users'

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider' ;
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
 
import InputLabel from '@mui/material/InputLabel';


const UserProfile = () => {
    //const { id,name,username,email, pincode ,phoneNo ,place ,districtID, talukID } = useSelector(state=>state.user.data);
  
   const [formData,setFormData] = useState(formValues)
   const [loading,setLoading] = useState(true);
   const [editorBlur,setEditorBlur] = useState(false);
   
    

   let state={
        id:0,
        name:"Name",
        username:"User Name",
        email:"email",
        phoneNo:"phone number",
        pincode:"Pincode",
        place1:"place",
        createdDate:"Date",
        activated:"activated",
        status:"status",
        designation:"designation",
        districtID:1,
        talukID:1,
        regnlID:1,
        validationFrom:"validationFrom",
        validationTO:"validationTO",
        roles:"roles"
              }
  

    const formik = useFormik({
        enableReinitialize: true,
        initialValues:formData,
        onSubmit:(values)=>{
            dispatch(updateUserProfile(values))
        }
    })

    const dispatch = useDispatch();
 

    const handleEditorBlur = (blur) => {
        setEditorBlur(true)
    }
     
     ///// edit 
     useEffect(()=>{
       
        dispatch(getuserDetails())
        .unwrap()
        .then(response => {

            setLoading(false);
          

       
       
            state.id=response.data.id;
            state.name=response.data.name;
            state.username=response.data.username;
            state.email=response.data.email;
            state.phoneNo=response.data.phoneNo;
            state.place=response.data.place;
            state.pincode=response.data.pincode;
            state.createdDate=response.data.createdDate;
            state.activated=response.data.activated;
            state.status=response.data.status;
            state.designation=response.data.designation;
            state.districtID=response.data.districtID;
            state.talukID=response.data.talukID;
            state.regnlID=response.data.regnlID;
            state.validationFrom=response.data.validationFrom;
            state.validationTO=response.data.validationTO;
            state.roles=response.data.roles[0].name;
            
            setFormData(state);     

 
       
        })

    },[dispatch])


    return(
        <>{loading ?
            <Loader/>
        :
          <form className='mt-3 article_form' style={{ maxWidth:'250px'}}
            onSubmit={formik.handleSubmit}
          >



              <div className='form-group'>
                <TextField
                    style={{width:'100%'}}
                    name="id"
                    label="User ID "
                    variant='outlined'

            
                    {...formik.getFieldProps('id')}
                    {...errorHelper(formik,'id')}
                />
              </div>
              <div className='form-group'>
                <TextField
                    style={{width:'100%'}}
                    name="name"
                    label="Name"
                    variant='outlined'
                    {...formik.getFieldProps('name')}
                    {...errorHelper(formik,'name')}
                />
                
              </div>
              <div className='form-group'>
                <TextField
                    style={{width:'100%'}}
                    name="username"
                    label="User Name"
                    variant='outlined'
                    {...formik.getFieldProps('username')}
                    {...errorHelper(formik,'username')}
                />
              </div>

              {/* <div className='form-group'>
                <TextField
                    style={{width:'100%'}}
                    name="email"
                    label="email ID"
                    variant='outlined'
                    {...formik.getFieldProps('email')}
                    {...errorHelper(formik,'email')}
                />
              </div> */}

              <div className='form-group'>
                <TextField
                    style={{width:'100%'}}
                    name="pincode"
                    label="Pincode"
                    variant='outlined'
                    {...formik.getFieldProps('pincode')}
                    {...errorHelper(formik,'pincode')}
                />
              </div>
              
     

              {/* <div className='form-group'>
                <TextField
                    style={{width:'100%'}}
                    name="phoneNo"
                    label="Mobile Number"
                    variant='outlined'
                    {...formik.getFieldProps('phoneNo')}
                    {...errorHelper(formik,'phoneNo')}
                />
              </div> */}

             
            
              

              <div className='form-group'>
                <TextField
                    style={{width:'100%'}}
                    name="place"
                    label="place"
                    variant='outlined'
                    {...formik.getFieldProps('place')}
                    {...errorHelper(formik,'place')}
                />
              </div>
              
             
              <div className='form-group'>
            <FormControl fullWidth>
            
                <InputLabel>Select your District</InputLabel>
                <Select
                    name="districtID"
                    label="Select your District"
                    {...formik.getFieldProps('districtID')}
                    error={ formik.errors.districtID && formik.touched.districtID ? true:false}
                >
                    <MenuItem value={1}><em>Kolar</em></MenuItem>
                    <MenuItem value={2}>Bengaluru</MenuItem>
                    <MenuItem value={3}>Mysore</MenuItem>
                </Select>
                { formik.errors.districtID && formik.touched.districtID ?
                    <FormHelperText error={true}>
                        { formik.errors.districtID}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>

<Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
                <InputLabel>Select your Taluk</InputLabel>
                <Select
                    name="talukID"
                    label="Select your talukID"
                    {...formik.getFieldProps('talukID')}
                    error={ formik.errors.talukID && formik.touched.talukID ? true:false}
                >
                    <MenuItem value={1}><em>Malur</em></MenuItem>
                    <MenuItem value={2}>Kolar</MenuItem>
                    <MenuItem value={3}>Bangarapete</MenuItem>
                </Select>
                { formik.errors.talukID && formik.touched.talukID ?
                    <FormHelperText error={true}>
                        { formik.errors.talukID}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>
              <Button
                className='mt-3'
                variant='contained'
                color='primary'
                type='submit'
              >
                  Edit profile
              </Button>


          </form>
            }
        </>
    )

}


export default  UserProfile